<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="White-label E-Wallet System by County" name="description"/>
      <meta content="County Development Team" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- Custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">E-WALLET MANAGEMENT</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">E-Wallet</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- E-Wallet Overview Cards -->
            <div class="row">
              <div class="col-xl-3 col-md-6">
                <div class="card wallet-card bg-primary text-white">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-white-50 mb-1">Total Wallets</p>
                        <h4 class="mb-0 text-white">{{ formatNumber(walletStats.totalWallets) }}</h4>
                      </div>
                      <div class="flex-shrink-0">
                        <i class="mdi mdi-wallet font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card wallet-card bg-success text-white">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-white-50 mb-1">Total Balance</p>
                        <h4 class="mb-0 text-white">{{ formatPrice(walletStats.totalBalance) }}</h4>
                      </div>
                      <div class="flex-shrink-0">
                        <i class="mdi mdi-cash-multiple font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card wallet-card bg-info text-white">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-white-50 mb-1">Daily Transactions</p>
                        <h4 class="mb-0 text-white">{{ formatNumber(walletStats.dailyTransactions) }}</h4>
                      </div>
                      <div class="flex-shrink-0">
                        <i class="mdi mdi-swap-horizontal font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card wallet-card bg-warning text-white">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-white-50 mb-1">Active Cards</p>
                        <h4 class="mb-0 text-white">{{ formatNumber(walletStats.activeCards) }}</h4>
                      </div>
                      <div class="flex-shrink-0">
                        <i class="mdi mdi-credit-card font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Wallet Management Interface -->
            <div class="row">
              <!-- Wallet List -->
              <div class="col-xl-8">
                <div class="card">
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">Wallet Accounts</h4>
                      <div>
                        <button @click="showCreateWalletModal" class="btn btn-primary me-2">
                          <i class="mdi mdi-plus-circle-outline"></i> Create Wallet
                        </button>
                        <button @click="showBulkOperationsModal" class="btn btn-secondary">
                          <i class="mdi mdi-cog"></i> Bulk Operations
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Wallet Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-center">
                      <div class="col-md-3">
                        <label class="form-label mb-1">Wallet Type:</label>
                        <select v-model="selectedWalletType" @change="filterWallets()" class="form-select">
                          <option value="">All Types</option>
                          <option value="PERSONAL">Personal</option>
                          <option value="BUSINESS">Business</option>
                          <option value="GOVERNMENT">Government</option>
                          <option value="MERCHANT">Merchant</option>
                        </select>
                      </div>

                      <div class="col-md-3">
                        <label class="form-label mb-1">Status:</label>
                        <select v-model="selectedStatus" @change="filterWallets()" class="form-select">
                          <option value="">All Status</option>
                          <option value="ACTIVE">Active</option>
                          <option value="SUSPENDED">Suspended</option>
                          <option value="FROZEN">Frozen</option>
                          <option value="CLOSED">Closed</option>
                        </select>
                      </div>

                      <div class="col-md-6">
                        <label class="form-label mb-1">Search:</label>
                        <div class="position-relative">
                          <input v-model="searchQuery" @input="filterWallets()" type="text" class="form-control"
                                 placeholder="Search by wallet ID, phone, name...">
                          <i class="bx bx-search-alt position-absolute top-50 end-0 translate-middle-y me-3"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Wallet Table -->
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark">
                        <tr>
                          <th>Wallet ID</th>
                          <th>Account Holder</th>
                          <th>Type</th>
                          <th class="text-end">Balance</th>
                          <th>Status</th>
                          <th>Last Activity</th>
                          <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="wallet in filteredWallets" :key="wallet.walletId">
                          <td>
                            <span class="fw-semibold">{{ wallet.walletId }}</span>
                            <br>
                            <small class="text-muted">{{ wallet.accountNumber }}</small>
                          </td>
                          <td>
                            <div>
                              <strong>{{ wallet.holderName }}</strong>
                              <br>
                              <small class="text-muted">{{ maskPhoneNumber(wallet.phoneNumber) }}</small>
                              <br>
                              <small class="text-muted">{{ wallet.email }}</small>
                            </div>
                          </td>
                          <td>
                            <span class="badge" :class="getWalletTypeBadge(wallet.type)">
                              {{ wallet.type }}
                            </span>
                          </td>
                          <td class="text-end">
                            <span class="fw-semibold">{{ formatPrice(wallet.balance) }}</span>
                            <br>
                            <small class="text-muted">Available: {{ formatPrice(wallet.availableBalance) }}</small>
                          </td>
                          <td>
                            <span class="badge" :class="getStatusBadge(wallet.status)"
                                  @click="toggleWalletStatus(wallet)" style="cursor: pointer;">
                              {{ wallet.status }}
                            </span>
                          </td>
                          <td>
                            <div>
                              {{ wallet.lastActivity }}
                              <br>
                              <small class="text-muted">{{ wallet.lastActivityType }}</small>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex">
                              <button @click="openWalletDetails(wallet)"
                                      class="btn btn-primary btn-sm me-1"
                                      data-bs-toggle="modal" data-bs-target="#walletDetailModal">
                                <i class="mdi mdi-eye"></i>
                              </button>
                              <div class="dropdown">
                                <button class="btn btn-outline-secondary btn-sm dropdown-toggle"
                                        data-bs-toggle="dropdown">
                                  <i class="bx bx-dots-vertical"></i>
                                </button>
                                <ul class="dropdown-menu">
                                  <li><a class="dropdown-item" @click="initiateTransfer(wallet)">
                                    <i class="mdi mdi-bank-transfer me-2"></i>Transfer</a></li>
                                  <li><a class="dropdown-item" @click="addFunds(wallet)">
                                    <i class="mdi mdi-plus-circle me-2"></i>Add Funds</a></li>
                                  <li><a class="dropdown-item" @click="freezeFunds(wallet)">
                                    <i class="mdi mdi-lock me-2"></i>Freeze Funds</a></li>
                                  <li><a class="dropdown-item" @click="generateStatement(wallet)">
                                    <i class="mdi mdi-file-document me-2"></i>Statement</a></li>
                                  <li><a class="dropdown-item" @click="issueCard(wallet)">
                                    <i class="mdi mdi-credit-card me-2"></i>Issue Card</a></li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>

                      <!-- Loading State -->
                      <div v-if="loading" class="text-center p-5">
                        <div class="spinner-border text-info mb-3" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <h4>Loading Wallets</h4>
                        <p>Fetching wallet data...</p>
                      </div>

                      <!-- No Results -->
                      <div v-if="filteredWallets.length < 1 && !loading" class="text-center p-5">
                        <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                        <h4>No Wallets Found</h4>
                        <p>No wallets match your current filter criteria.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Quick Actions Panel -->
              <div class="col-xl-4">
                <!-- Real-time Transaction Monitor -->
                <div class="card">
                  <div class="card-header bg-white border-bottom">
                    <h5 class="card-title mb-0">
                      <i class="mdi mdi-pulse text-success me-2"></i>
                      Live Transactions
                    </h5>
                  </div>
                  <div class="card-body p-0" style="max-height: 400px; overflow-y: auto;">
                    <div v-for="transaction in liveTransactions" :key="transaction.id"
                         class="d-flex align-items-center p-3 border-bottom">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar-xs">
                          <span class="avatar-title rounded-circle"
                                :class="getTransactionIcon(transaction.type).class">
                            <i :class="getTransactionIcon(transaction.type).icon"></i>
                          </span>
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="mb-1">{{ transaction.description }}</h6>
                        <p class="text-muted mb-0">
                          <small>{{ transaction.walletId }} • {{ transaction.timestamp }}</small>
                        </p>
                      </div>
                      <div class="flex-shrink-0">
                        <span class="fw-semibold"
                              :class="transaction.amount > 0 ? 'text-success' : 'text-danger'">
                          {{ transaction.amount > 0 ? '+' : '' }}{{ formatPrice(Math.abs(transaction.amount)) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Card Management -->
                <div class="card mt-3">
                  <div class="card-header bg-white border-bottom">
                    <h5 class="card-title mb-0">
                      <i class="mdi mdi-credit-card text-primary me-2"></i>
                      Card Management
                    </h5>
                  </div>
                  <div class="card-body">
                    <div class="row g-3">
                      <div class="col-6">
                        <div class="card border text-center p-3">
                          <i class="mdi mdi-credit-card-chip font-size-24 text-primary mb-2"></i>
                          <h6>Physical Cards</h6>
                          <h4 class="text-primary">{{ cardStats.physicalCards }}</h4>
                          <button @click="orderPhysicalCards" class="btn btn-sm btn-primary">Order Cards</button>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="card border text-center p-3">
                          <i class="mdi mdi-cellphone-nfc font-size-24 text-success mb-2"></i>
                          <h6>Virtual Cards</h6>
                          <h4 class="text-success">{{ cardStats.virtualCards }}</h4>
                          <button @click="issueVirtualCard" class="btn btn-sm btn-success">Issue Virtual</button>
                        </div>
                      </div>
                    </div>

                    <div class="mt-3">
                      <h6>Card Production Queue</h6>
                      <div class="progress mb-2">
                        <div class="progress-bar" role="progressbar"
                             :style="{width: cardProduction.progress + '%'}">
                          {{ cardProduction.progress }}%
                        </div>
                      </div>
                      <small class="text-muted">
                        {{ cardProduction.inQueue }} cards in production queue
                      </small>
                    </div>
                  </div>
                </div>

                <!-- System Integration Status -->
                <div class="card mt-3">
                  <div class="card-header bg-white border-bottom">
                    <h5 class="card-title mb-0">
                      <i class="mdi mdi-link-variant text-info me-2"></i>
                      Integration Status
                    </h5>
                  </div>
                  <div class="card-body">
                    <div v-for="integration in systemIntegrations" :key="integration.name"
                         class="d-flex align-items-center justify-content-between mb-3">
                      <div>
                        <h6 class="mb-1">{{ integration.name }}</h6>
                        <small class="text-muted">{{ integration.description }}</small>
                      </div>
                      <div>
                        <span class="badge" :class="integration.status === 'ACTIVE' ? 'bg-success' : 'bg-danger'">
                          {{ integration.status }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Wallet Detail Modal -->
        <WalletDetailModal
            :wallet="selectedWallet"
            :transactions="walletTransactions"
            :cards="walletCards"
            @transfer-funds="handleTransferFunds"
            @block-card="handleBlockCard"
            @unblock-card="handleUnblockCard"
        />

        <!-- Create Wallet Modal -->
        <CreateWalletModal
            @wallet-created="handleWalletCreated"
        />

        <!-- Transfer Modal -->
        <TransferModal
            :sourceWallet="transferSourceWallet"
            @transfer-completed="handleTransferCompleted"
        />

        <!-- Alert Toast -->
        <div v-if="alert.success || alert.failed || alert.info"
             class="toast-container position-fixed top-0 end-0 p-3">
          <div class="toast show" role="alert">
            <div class="toast-header" :class="{
                'bg-success text-white': alert.success,
                'bg-danger text-white': alert.failed,
                'bg-info text-white': alert.info
              }">
              <strong class="me-auto">E-Wallet Notification</strong>
              <button type="button" class="btn-close" @click="clearAlerts"></button>
            </div>
            <div class="toast-body">
              {{ message }}
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <div class="text-sm-start">
                  <i class="mdi mdi-shield-check text-success me-1"></i>
                  PCI DSS Compliant E-Wallet System
                </div>
              </div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County Development Team</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */

import { biller, execute, getRight } from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import WalletDetailModal from "@/components/wallet/modals/WalletDetailModal.vue";
import CreateWalletModal from "@/components/wallet/modals/CreateWalletModal.vue";
import TransferModal from "@/components/wallet/modals/TransferModal.vue";
import router from "@/router";
import moment from "moment";

export default {

  name: "EWalletManagement",
  components: {
    NavigationBar,
    WalletDetailModal,
    CreateWalletModal,
    TransferModal
  },
  data() {
    return {
      loading: false,
      searchQuery: '',
      selectedWalletType: '',
      selectedStatus: '',

      // Wallet Statistics
      walletStats: {
        totalWallets: 15847,
        totalBalance: 245673821.50,
        dailyTransactions: 3421,
        activeCards: 12563
      },

      // Card Statistics
      cardStats: {
        physicalCards: 8924,
        virtualCards: 15847,
      },

      // Card Production
      cardProduction: {
        progress: 78,
        inQueue: 342
      },

      // Wallet Data
      wallets: [
        {
          walletId: 'KE001234567890',
          accountNumber: 'ACC-001234567890',
          holderName: 'John Doe Kamau',
          phoneNumber: '+254712345678',
          email: 'john.kamau@email.com',
          type: 'PERSONAL',
          balance: 125000.00,
          availableBalance: 123500.00,
          status: 'ACTIVE',
          lastActivity: '2025-07-15 14:30',
          lastActivityType: 'Mobile Payment',
          dateCreated: '2025-01-15',
          kycStatus: 'VERIFIED',
          tier: 'TIER_3'
        },
        {
          walletId: 'KE001234567891',
          accountNumber: 'ACC-001234567891',
          holderName: 'Sarah Wanjiku Enterprises',
          phoneNumber: '+254722345679',
          email: 'sarah@sarahenterprises.co.ke',
          type: 'BUSINESS',
          balance: 2450000.00,
          availableBalance: 2445000.00,
          status: 'ACTIVE',
          lastActivity: '2025-07-15 13:45',
          lastActivityType: 'Bulk Transfer',
          dateCreated: '2024-11-20',
          kycStatus: 'VERIFIED',
          tier: 'BUSINESS_TIER_2'
        },
        {
          walletId: 'KE001234567892',
          accountNumber: 'ACC-001234567892',
          holderName: 'County Government of Nairobi',
          phoneNumber: '+254720000001',
          email: 'payments@nairobi.go.ke',
          type: 'GOVERNMENT',
          balance: 15750000.00,
          availableBalance: 15750000.00,
          status: 'ACTIVE',
          lastActivity: '2025-07-15 15:20',
          lastActivityType: 'Revenue Collection',
          dateCreated: '2024-08-01',
          kycStatus: 'VERIFIED',
          tier: 'GOVERNMENT'
        },
        {
          walletId: 'KE001234567893',
          accountNumber: 'ACC-001234567893',
          holderName: 'Mary Njeri Mwangi',
          phoneNumber: '+254733345680',
          email: 'mary.njeri@email.com',
          type: 'PERSONAL',
          balance: 45000.00,
          availableBalance: 45000.00,
          status: 'SUSPENDED',
          lastActivity: '2025-07-10 09:15',
          lastActivityType: 'ATM Withdrawal',
          dateCreated: '2025-03-10',
          kycStatus: 'PENDING',
          tier: 'TIER_1'
        },
        {
          walletId: 'KE001234567894',
          accountNumber: 'ACC-001234567894',
          holderName: 'TechHub Solutions Ltd',
          phoneNumber: '+254744456781',
          email: 'finance@techhub.co.ke',
          type: 'MERCHANT',
          balance: 1250000.00,
          availableBalance: 1247500.00,
          status: 'ACTIVE',
          lastActivity: '2025-07-15 16:10',
          lastActivityType: 'Merchant Settlement',
          dateCreated: '2024-09-15',
          kycStatus: 'VERIFIED',
          tier: 'MERCHANT_PREMIUM'
        }
      ],

      filteredWallets: [],

      // Live Transactions
      liveTransactions: [
        {
          id: 'TX001',
          walletId: 'KE001234567890',
          description: 'Mobile Money Transfer',
          amount: -5000,
          timestamp: '14:35:22',
          type: 'TRANSFER'
        },
        {
          id: 'TX002',
          walletId: 'KE001234567892',
          description: 'Revenue Collection',
          amount: 25000,
          timestamp: '14:34:15',
          type: 'COLLECTION'
        },
        {
          id: 'TX003',
          walletId: 'KE001234567894',
          description: 'Merchant Payment',
          amount: 12500,
          timestamp: '14:33:08',
          type: 'PAYMENT'
        },
        {
          id: 'TX004',
          walletId: 'KE001234567891',
          description: 'Bulk Salary Payment',
          amount: -150000,
          timestamp: '14:32:45',
          type: 'BULK_TRANSFER'
        },
        {
          id: 'TX005',
          walletId: 'KE001234567890',
          description: 'Card Purchase',
          amount: -2350,
          timestamp: '14:31:30',
          type: 'CARD_PAYMENT'
        }
      ],

      // System Integrations
      systemIntegrations: [
        {
          name: 'Visa/Mastercard Network',
          description: 'Card processing network',
          status: 'ACTIVE'
        },
        {
          name: 'M-Pesa Integration',
          description: 'Mobile money gateway',
          status: 'ACTIVE'
        },
        {
          name: 'KCB Bank Gateway',
          description: 'Core banking integration',
          status: 'ACTIVE'
        },
        {
          name: 'Central Bank RTGS',
          description: 'Real-time gross settlement',
          status: 'ACTIVE'
        },
        {
          name: 'POS Terminal Network',
          description: 'Point of sale integration',
          status: 'ACTIVE'
        },
        {
          name: 'ATM Network',
          description: 'Automated teller machines',
          status: 'MAINTENANCE'
        }
      ],

      // Modal Data
      selectedWallet: {},
      walletTransactions: [],
      walletCards: [],
      transferSourceWallet: {},

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    }
  },
  mounted() {
    this.filteredWallets = [...this.wallets];
    this.startLiveTransactionUpdates();
    this.menuAccess();
  },
  beforeUnmount() {
    if (this.transactionInterval) {
      clearInterval(this.transactionInterval);
    }
  },
  methods: {
    getRight,

    // Utility Methods
    formatPrice(value) {
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value);
    },

    formatNumber(value) {
      return new Intl.NumberFormat('en-KE').format(value);
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 4) + input.slice(4, -2).replace(/\d/g, '*') + input.slice(-2);
      }
      return input;
    },

    gotTo(route) {
      router.push(route);
    },

    // Alert Methods
    clearAlerts() {
      this.alert = { success: false, info: false, failed: false };
      this.message = '';
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      setTimeout(() => {
        this.clearAlerts();
      }, 5000);
    },

    // Filter Methods
    filterWallets() {
      let filtered = [...this.wallets];

      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        filtered = filtered.filter(wallet =>
            wallet.walletId.toLowerCase().includes(query) ||
            wallet.holderName.toLowerCase().includes(query) ||
            wallet.phoneNumber.includes(query) ||
            wallet.email.toLowerCase().includes(query)
        );
      }

      if (this.selectedWalletType) {
        filtered = filtered.filter(wallet => wallet.type === this.selectedWalletType);
      }

      if (this.selectedStatus) {
        filtered = filtered.filter(wallet => wallet.status === this.selectedStatus);
      }

      this.filteredWallets = filtered;
    },

    // Badge Methods
    getWalletTypeBadge(type) {
      const badges = {
        'PERSONAL': 'bg-primary',
        'BUSINESS': 'bg-success',
        'GOVERNMENT': 'bg-info',
        'MERCHANT': 'bg-warning'
      };
      return badges[type] || 'bg-secondary';
    },

    getStatusBadge(status) {
      const badges = {
        'ACTIVE': 'bg-success',
        'SUSPENDED': 'bg-warning',
        'FROZEN': 'bg-danger',
        'CLOSED': 'bg-secondary'
      };
      return badges[status] || 'bg-secondary';
    },

    getTransactionIcon(type) {
      const icons = {
        'TRANSFER': { icon: 'mdi mdi-bank-transfer', class: 'bg-primary' },
        'COLLECTION': { icon: 'mdi mdi-cash-plus', class: 'bg-success' },
        'PAYMENT': { icon: 'mdi mdi-credit-card', class: 'bg-info' },
        'BULK_TRANSFER': { icon: 'mdi mdi-account-multiple', class: 'bg-warning' },
        'CARD_PAYMENT': { icon: 'mdi mdi-contactless-payment', class: 'bg-secondary' }
      };
      return icons[type] || { icon: 'mdi mdi-cash', class: 'bg-secondary' };
    },

    // Live Transaction Updates
    startLiveTransactionUpdates() {
      this.transactionInterval = setInterval(() => {
        // Simulate new transactions
        const newTransaction = {
          id: 'TX' + Date.now(),
          walletId: this.wallets[Math.floor(Math.random() * this.wallets.length)].walletId,
          description: this.getRandomTransactionDescription(),
          amount: (Math.random() - 0.5) * 50000,
          timestamp: moment().format('HH:mm:ss'),
          type: this.getRandomTransactionType()
        };

        this.liveTransactions.unshift(newTransaction);
        if (this.liveTransactions.length > 10) {
          this.liveTransactions.pop();
        }

        // Update statistics
        this.walletStats.dailyTransactions++;
      }, 3000);
    },

    getRandomTransactionDescription() {
      const descriptions = [
        'Mobile Money Transfer', 'Card Payment', 'ATM Withdrawal', 'Online Purchase',
        'Bill Payment', 'Salary Credit', 'Merchant Payment', 'Bulk Transfer',
        'Revenue Collection', 'Loan Disbursement'
      ];
      return descriptions[Math.floor(Math.random() * descriptions.length)];
    },

    getRandomTransactionType() {
      const types = ['TRANSFER', 'COLLECTION', 'PAYMENT', 'BULK_TRANSFER', 'CARD_PAYMENT'];
      return types[Math.floor(Math.random() * types.length)];
    },

    // Wallet Operations
    async toggleWalletStatus(wallet) {
      const newStatus = wallet.status === 'ACTIVE' ? 'SUSPENDED' : 'ACTIVE';
      const confirmed = confirm(`Are you sure you want to ${newStatus.toLowerCase()} this wallet?`);

      if (confirmed) {
        // Simulate API call
        try {
          wallet.status = newStatus;
          this.showAlert('success', `Wallet ${newStatus.toLowerCase()} successfully`);
        } catch (e) {
          this.showAlert('failed', 'Failed to update wallet status');
        }
      }
    },

    openWalletDetails(wallet) {
      this.selectedWallet = wallet;
      // Load wallet transactions and cards
      this.loadWalletTransactions(wallet.walletId);
      this.loadWalletCards(wallet.walletId);
    },

    async loadWalletTransactions(walletId) {
      // Hardcoded transaction data
      this.walletTransactions = [
        {
          id: 'TXN001',
          date: '2025-07-15 14:30',
          description: 'Mobile Payment to Merchant',
          type: 'DEBIT',
          amount: -5000,
          balance: 125000,
          reference: 'MP20250715143001',
          channel: 'MOBILE_APP'
        },
        {
          id: 'TXN002',
          date: '2025-07-15 12:15',
          description: 'Salary Credit',
          type: 'CREDIT',
          amount: 85000,
          balance: 130000,
          reference: 'SAL20250715121501',
          channel: 'BANK_TRANSFER'
        },
        {
          id: 'TXN003',
          date: '2025-07-14 16:45',
          description: 'ATM Withdrawal',
          type: 'DEBIT',
          amount: -10000,
          balance: 45000,
          reference: 'ATM20250714164501',
          channel: 'ATM'
        }
      ];
    },

    async loadWalletCards(walletId) {
      // Hardcoded card data
      this.walletCards = [
        {
          id: 'CRD001',
          cardNumber: '**** **** **** 1234',
          cardType: 'PHYSICAL',
          brand: 'VISA',
          status: 'ACTIVE',
          expiryDate: '12/28',
          dailyLimit: 50000,
          monthlyLimit: 200000,
          issuedDate: '2025-01-15'
        },
        {
          id: 'CRD002',
          cardNumber: '**** **** **** 5678',
          cardType: 'VIRTUAL',
          brand: 'MASTERCARD',
          status: 'ACTIVE',
          expiryDate: '06/27',
          dailyLimit: 25000,
          monthlyLimit: 100000,
          issuedDate: '2025-03-10'
        }
      ];
    },

    // Modal Operations
    showCreateWalletModal() {
      // Trigger create wallet modal
      const modal = new bootstrap.Modal(document.getElementById('createWalletModal'));
      modal.show();
    },

    showBulkOperationsModal() {
      this.showAlert('info', 'Bulk operations modal would open here');
    },

    // Transfer Operations
    initiateTransfer(wallet) {
      this.transferSourceWallet = wallet;
      const modal = new bootstrap.Modal(document.getElementById('transferModal'));
      modal.show();
    },

    handleTransferFunds(transferData) {
      this.showAlert('success', 'Transfer initiated successfully');
    },

    handleTransferCompleted(transferData) {
      this.showAlert('success', `Transfer of ${this.formatPrice(transferData.amount)} completed successfully`);
      // Refresh wallet data
      this.filteredWallets = [...this.wallets];
    },

    // Fund Operations
    addFunds(wallet) {
      const amount = prompt('Enter amount to add:');
      if (amount && !isNaN(amount)) {
        wallet.balance += parseFloat(amount);
        wallet.availableBalance += parseFloat(amount);
        this.showAlert('success', `${this.formatPrice(amount)} added to wallet ${wallet.walletId}`);
      }
    },

    freezeFunds(wallet) {
      const amount = prompt('Enter amount to freeze:');
      if (amount && !isNaN(amount)) {
        wallet.availableBalance -= parseFloat(amount);
        this.showAlert('success', `${this.formatPrice(amount)} frozen in wallet ${wallet.walletId}`);
      }
    },

    // Report Operations
    generateStatement(wallet) {
      this.showAlert('info', `Generating statement for wallet ${wallet.walletId}...`);

      // Simulate statement generation
      setTimeout(() => {
        const link = document.createElement('a');
        link.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(`
Wallet Statement
Account: ${wallet.walletId}
Holder: ${wallet.holderName}
Generated: ${moment().format('YYYY-MM-DD HH:mm:ss')}

Current Balance: ${this.formatPrice(wallet.balance)}
Available Balance: ${this.formatPrice(wallet.availableBalance)}
        `);
        link.download = `wallet_statement_${wallet.walletId}_${moment().format('YYYYMMDD')}.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.showAlert('success', 'Statement downloaded successfully');
      }, 2000);
    },

    // Card Operations
    issueCard(wallet) {
      const cardType = confirm('Issue Physical Card? (Cancel for Virtual Card)') ? 'PHYSICAL' : 'VIRTUAL';

      this.showAlert('success', `${cardType} card issuance initiated for wallet ${wallet.walletId}`);

      if (cardType === 'PHYSICAL') {
        this.cardStats.physicalCards++;
        this.cardProduction.inQueue++;
      } else {
        this.cardStats.virtualCards++;
      }
    },

    orderPhysicalCards() {
      const quantity = prompt('Enter number of cards to order:', '100');
      if (quantity && !isNaN(quantity)) {
        this.cardProduction.inQueue += parseInt(quantity);
        this.showAlert('success', `Order placed for ${quantity} physical cards`);
      }
    },

    issueVirtualCard() {
      this.cardStats.virtualCards++;
      this.showAlert('success', 'Virtual card issued successfully');
    },

    handleBlockCard(cardId) {
      this.showAlert('success', `Card ${cardId} blocked successfully`);
    },

    handleUnblockCard(cardId) {
      this.showAlert('success', `Card ${cardId} unblocked successfully`);
    },

    // Event Handlers
    handleWalletCreated(walletData) {
      this.wallets.unshift(walletData);
      this.filterWallets();
      this.walletStats.totalWallets++;
      this.showAlert('success', `Wallet ${walletData.walletId} created successfully`);
    },

    // System Methods
    async menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "E-Wallet Management");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    }
  }
}
</script>

<style scoped>
.wallet-card {
  transition: transform 0.2s;
}

.wallet-card:hover {
  transform: translateY(-2px);
}

.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}

.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75rem;
  cursor: pointer;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.card-header {
  padding: 1rem;
}

.toast-container {
  z-index: 9999;
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.avatar-title {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.progress {
  height: 8px;
}

.card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  transition: box-shadow 0.3s ease;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.text-success i {
  animation: pulse 2s infinite;
}
</style>